import React, { useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import Loader from "component/loader";
import { AuthLock } from "asset/icons";
import ErrorMessage from "pages/auth_v2/ErrorMessage";

const SetNewPinModal = ({ isOpen, onClose, onBack, onSubmit, loading, errorMessage }) => {
    const [pin, setPin] = useState(["", "", "", ""]);
    const inputRefs = useRef([]);

    const handleChange = (value, index) => {
        if (/^\d?$/.test(value)) {
            const newPin = [...pin];
            newPin[index] = value;
            setPin(newPin);
            if (value && index < 3) inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            const newPin = [...pin];
            if (pin[index]) {
                newPin[index] = "";
                setPin(newPin);
            } else if (index > 0) {
                inputRefs.current[index - 1]?.focus();
            }
        }
    };

    const handleSubmit = () => {
        const joined = pin.join("");
        if (joined.length === 4 && !loading) {
            onSubmit(joined);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[700] bg-black/40 flex items-center justify-center">
            <div className="bg-white rounded-2xl w-full max-w-lg relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-3xl text-[#101828]"
                >
                    <IoMdClose />
                </button>
                <div className="pt-2">
                    <AuthLock />
                </div>

                <div className="px-6 pb-6">
                    <h2 className="text-2xl font-semibold text-[#101828] mb-1">Set a new PIN</h2>
                    <p className="text-[#667085] !mb-6">
                        Create a new PIN for your transactions below
                    </p>

                    {errorMessage && <ErrorMessage message={errorMessage} />}

                    <div className="flex justify-start gap-4 mb-6">
                        {pin.map((digit, index) => (
                            <input
                                key={index}
                                type="password"
                                inputMode="numeric"
                                maxLength={1}
                                value={digit}
                                onChange={(e) => handleChange(e.target.value, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                ref={(el) => (inputRefs.current[index] = el)}
                                className="w-14 h-14 bg-[#F2F3FC] text-center text-2xl rounded-lg"
                            />
                        ))}
                    </div>
                </div>
                <div className="flex justify-end gap-4 border-t p-3">
                    <button
                        onClick={onBack}
                        className="text-[#344054] font-medium px-4 py-2 rounded"
                    >
                        Back
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={pin.some((d) => d === "") || loading}
                        className={`rounded px-6 py-2 font-medium text-white ${
                            pin.some((d) => d === "") || loading
                                ? "bg-[#E9D7FE] text-[#B3A8DD] cursor-not-allowed"
                                : "bg-[#6F00FF] hover:bg-[#5A00D6]"
                        }`}
                    >
                        {loading ? <Loader /> : "Confirm PIN"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SetNewPinModal;
